import { Controller } from "@hotwired/stimulus"
//explicitly create shadowdom so that it plays nice with turbo.
export default class extends Controller {
  connect(){
    let shadow = this.element.attachShadow({mode: "open", delegatesFocus: true})
    shadow.innerHTML = this.element.dataset.docsrc
  }
}